import axios from './axiosConfig';

const API_URL = process.env.NODE_ENV === 'production'

  ? "https://api.demo1.raborisk.ai"
  : "http://localhost:3000";

  const PYTHON_API_URL = process.env.NODE_ENV === 'production'

  ? "https://api.ai.raborisk.ai"
  : "https://api.ai.raborisk.ai";


export const FETCH_FLOWCHARTS = 'FETCH_FLOWCHARTS';
export const CREATE_FLOWCHART = 'CREATE_FLOWCHART';
export const UPDATE_FLOWCHART = 'UPDATE_FLOWCHART';
export const SELECT_FLOWCHART = 'SELECT_FLOWCHART';
export const SET_ERROR = 'SET_ERROR';
export const GENERATED_FLOWCHART_SUCCESS = 'GENERATED_FLOWCHART_SUCCESS';
export const GENERATED_FLOWCHART_FAILURE = 'GENERATED_FLOWCHART_FAILURE';
export const GENERATED_FLOWCHART_START = 'GENERATED_FLOWCHART_START';
export const DELETE_FLOWCHART = 'DELETE_FLOWCHART';
export const GET_FLOWCHART_BY_ID = 'GET_FLOWCHART_BY_ID';
export const FETCH_FLOWCHARTS_NEW = 'FETCH_FLOWCHARTS_NEW';
export const CREATEORUPDATE_FLOWCHART = 'CREATEORUPDATE_FLOWCHART';




export const createorupdateFlowchart = (data, departmentId) => {
    return (dispatch) => {
        const token = localStorage.getItem('token');
        //console.log("Here")
        return axios.post(`${API_URL}/api/flowchart/createorupdate`, {
            data,
            departmentId
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then(({ data }) => {
            dispatch({ type: CREATEORUPDATE_FLOWCHART, payload: data.results, risks: data.risks, assets: data.assets });
            return data;
        })
        .catch(error => {
            console.error('Error creating or updating flowchart:', error);
            dispatch({ type: SET_ERROR, payload: error.response?.data?.error || 'Failed to create or update flowchart' });
            throw error;
        });
    };
};

export const getFlowchartsNew = (departmentId) => {
    return (dispatch) => {
        //console.log("here Fetch")
        return axios.get(`${API_URL}/api/flowchart/get_flowcharts_new?department=${departmentId}`)
        .then(({ data }) => {
            dispatch({ type: FETCH_FLOWCHARTS_NEW, payload: data.results, risks: data.risks, assets: data.assets });
            return data;
        })
        .catch(error => {
            console.error('Error fetching flowcharts:', error);
            dispatch({ type: SET_ERROR, payload: error.response?.data?.error || 'Failed to fetch flowcharts' });
            throw error;
        });
    };
};


export const fetchFlowcharts = ( departmentId = null, complianceId = null) => {
  return (dispatch) => {
    const token = localStorage.getItem('token');

    const params = new URLSearchParams();
    if (departmentId) params.append('department', departmentId);
    if (complianceId) params.append('compliance', complianceId);

    return axios.get(
      `${API_URL}/api/flowchart/get_flowcharts?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then(({ data }) => {
        if (data.error) throw new Error(data.error);

        dispatch({ type: FETCH_FLOWCHARTS, payload: data });
        return data;
      })
      .catch((error) => {
        console.error('Error fetching flowcharts:', error);
        // dispatch({
        //   type: SET_ERROR,
        //   payload: error.response?.data?.error || 'Failed to fetch flowcharts',
        // });
        throw error;
      });
  };
};


export const getFlowchartById = (id) => {
    return (dispatch) => {
        // Get token from localStorage
        const token = localStorage.getItem('token');
        //console.log("here by id")
        ////console.log('getFlowchartById - Starting fetch for ID:', id);
        
        // First get the flowchart
        axios.get(`${API_URL}/api/flowchart/get_flowchart_by_id?id=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then(({ data }) => {
            ////console.log('getFlowchartById - Raw API response:', data);
            ////console.log('getFlowchartById - Risks in response:', data.risks);
            
            if (data.error) {
                throw new Error(data.error);
            }
            
            // Handle the case where data is an array
            const flowchart = Array.isArray(data) ? data[0] : data;
            ////console.log('getFlowchartById - Processed flowchart:', flowchart);
            ////console.log('getFlowchartById - Risks in flowchart:', flowchart.risks);

            // If there's a content field, parse it
            if (flowchart.content) {
                try {
                    const content = JSON.parse(flowchart.content);
                    ////console.log('getFlowchartById - Dispatching with parsed content');
                    dispatch({ 
                        type: GET_FLOWCHART_BY_ID, 
                        payload: {
                            ...flowchart,
                            ...content
                        },
                        risks: flowchart.risks || [],
                        assets: data.assets || []
                    });
                } catch (e) {
                    console.error('getFlowchartById - Error parsing content:', e);
                    dispatch({ type: SET_ERROR, payload: 'Invalid flowchart data format' });
                }
            } else {
                ////console.log('getFlowchartById - Dispatching without content parsing');
                dispatch({ 
                    type: GET_FLOWCHART_BY_ID, 
                    payload: flowchart,
                    risks: flowchart.risks || [],
                    assets: data.assets || []
                });
            }
        })
        .catch(error => {
            console.error('getFlowchartById - Error:', error);
            console.error('getFlowchartById - Error response:', error.response);
            dispatch({ type: SET_ERROR, payload: error.response?.data?.error || 'Failed to fetch flowchart' });
        });
    };
};

export const createFlowchart = (data) => {
    return (dispatch) => {
        const token = localStorage.getItem('token');
        ////console.log("user_id ", data.user_id)
        return axios.post(`${API_URL}/api/flowchart/create`, {
            name: data.name,
            nodes: [],
            edges: [],
            department: data.department,
            user_id: data.user_id
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then((response) => {
            if (response.data && response.data.id) {
                const newFlowchart = {
                    id: response.data.id,
                    name: data.name,
                    nodes: [],
                    edges: [],
                    department: data.department,
                    created_at: new Date().toISOString()
                };
                dispatch({ 
                    type: CREATE_FLOWCHART, 
                    payload: newFlowchart
                });
                return newFlowchart;
            } else {
                throw new Error('Invalid response format');
            }
        })
        .catch(error => {
            console.error('Error creating flowchart:', error.response || error);
            dispatch({ 
                type: SET_ERROR, 
                payload: error.response?.data?.error || 'Failed to create flowchart' 
            });
            throw error;
        });
    };
};


export const createFlowchartComp = (data) => {
    return (dispatch) => {
        const token = localStorage.getItem('token');
        ////console.log("user_id ", data.user_id)
        return axios.post(`${API_URL}/api/flowchart/create`, {
            name: data.name,
            nodes: [],
            edges: [],
            compliance: data.compliance,
            user_id: data.user_id
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then((response) => {
            if (response.data && response.data.id) {
                const newFlowchart = {
                    id: response.data.id,
                    name: data.name,
                    nodes: [],
                    edges: [],
                    compliance: data.compliance_id,
                    created_at: new Date().toISOString()
                };
                dispatch({ 
                    type: CREATE_FLOWCHART, 
                    payload: newFlowchart
                });
                return newFlowchart;
            } else {
                throw new Error('Invalid response format');
            }
        })
        .catch(error => {
            console.error('Error creating flowchart:', error.response || error);
            dispatch({ 
                type: SET_ERROR, 
                payload: error.response?.data?.error || 'Failed to create flowchart' 
            });
            throw error;
        });
    };
};

export const updateFlowchart = (id, nodes, edges) => {
    return (dispatch) => {
        return axios.put(`${API_URL}/api/flowchart/update_flowchart`, {
            id,
            nodes,
            edges
        })
        .then(({ data }) => {
            dispatch({ type: UPDATE_FLOWCHART, payload: { id, nodes, edges } });
            return data;
        })
        .catch(error => {
            console.error('Error updating flowchart:', error);
            dispatch({ type: SET_ERROR, payload: error.response?.data?.error || 'Failed to update flowchart' });
            throw error;
        });
    };
};

export const deleteFlowchart = (id) => {
    return (dispatch) => {
        const token = localStorage.getItem('token');
        
        return axios.delete(`${API_URL}/api/flowchart/delete_flowchart/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then(response => {
            dispatch({ type: DELETE_FLOWCHART, payload: id });
            return response.data;
        })
        .catch(error => {
            console.error('Error in deleteFlowchart:', error);
            dispatch({ type: SET_ERROR, payload: error.response?.data?.error || 'Failed to delete flowchart' });
            throw error;
        });
    };
};

// export const generateFlowchartFromDescription = (description, nodes, edges) => {
//   return (dispatch) => {
//     dispatch({ type: 'GENERATED_FLOWCHART_START' });

//     return axios.post(`${API_URL}/api/flowchart/generate`, { description, nodes, edges })
//       .then(({ data }) => {
//         dispatch({ type: 'GENERATED_FLOWCHART_SUCCESS' });
//         return data; // let the caller (e.g., your component) use the result
//       })
//       .catch(error => {
//         console.error('Error generating flowchart:', error);
//         dispatch({ type: 'GENERATED_FLOWCHART_FAILURE', payload: error.message });
//         throw error;
//       });
//   };
// };


export const generateFlowchartFromDescription =
  (description, initialNodes = [], initialEdges = []) =>
  async dispatch => {
    dispatch({ type: "GENERATED_FLOWCHART_START" });

    const res = await fetch(`${PYTHON_API_URL}/flowchart`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        description,
        nodes: initialNodes,
        edges: initialEdges
      })
    });

    if (!res.ok) {
      const errMsg = `HTTP ${res.status}`;
      dispatch({ type: "GENERATED_FLOWCHART_FAILURE", payload: errMsg });
      throw new Error(errMsg);
    }

    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let textBuf = "";

    const nodes = [];
    const edges = [];

    const spreadNodes = (rawNodes = []) => {
      const MIN_X_GAP = 260;
      const MIN_Y_GAP = 140;

      return rawNodes
        .map((node, index) => {
          const x = node?.position?.x ?? 0;
          const y = node?.position?.y ?? 0;

          return {
            ...node,
            position: {
              x: x * 1.35 + (index % 4) * 40,
              y: y * 1.2 + Math.floor(index / 4) * 20,
            },
          };
        })
        .reduce((acc, node) => {
          const tooClose = acc.find(existing => {
            const dx = Math.abs((existing.position?.x ?? 0) - (node.position?.x ?? 0));
            const dy = Math.abs((existing.position?.y ?? 0) - (node.position?.y ?? 0));
            return dx < MIN_X_GAP && dy < MIN_Y_GAP;
          });

          if (!tooClose) {
            acc.push(node);
            return acc;
          }

          acc.push({
            ...node,
            position: {
              x: (node.position?.x ?? 0) + MIN_X_GAP,
              y: (node.position?.y ?? 0) + MIN_Y_GAP / 2,
            },
          });

          return acc;
        }, []);
    };

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;

      textBuf += decoder.decode(value, { stream: true });

      let nl;
      while ((nl = textBuf.indexOf("\n")) !== -1) {
        const line = textBuf.slice(0, nl).trim();
        textBuf = textBuf.slice(nl + 1);

        if (!line) continue;

        let obj;
        try {
          obj = JSON.parse(line);
        } catch {
          continue;
        }

        const isEdge = obj?.source && obj?.target;

        if (isEdge) {
          edges.push(obj);
        } else {
          nodes.push(obj);
        }

        dispatch({
          type: "GENERATED_FLOWCHART_PARTIAL",
          payload: {
            obj,
            partialNodes: [...nodes],
            partialEdges: [...edges]
          }
        });
      }
    }

    const finalNodes = spreadNodes(nodes);
    const nodeIds = new Set(finalNodes.map(n => n.id));
    const finalEdges = edges.filter(e => nodeIds.has(e.source) && nodeIds.has(e.target));

    dispatch({
      type: "GENERATED_FLOWCHART_SUCCESS",
      payload: { nodes: finalNodes, edges: finalEdges }
    });

    return { nodes: finalNodes, edges: finalEdges };
  };

/**
 * 🚫 AI DISABLED — DEMO MODE
 * Mimics flowchart generation with empty output
 */
// export const generateFlowchartFromDescription =
//   (description, initialNodes = [], initialEdges = []) =>
//   async (dispatch) => {
//     dispatch({ type: "GENERATED_FLOWCHART_START" });

//     // small artificial delay so UI feels normal
//     await new Promise((res) => setTimeout(res, 200));

//     const nodes = []; // or [...initialNodes] if you prefer
//     const edges = []; // or [...initialEdges]

//     // Optional: emit a single partial update (some reducers expect it)
//     dispatch({
//       type: "GENERATED_FLOWCHART_PARTIAL",
//       payload: {
//         obj: null,
//         partialNodes: nodes,
//         partialEdges: edges,
//       },
//     });

//     dispatch({
//       type: "GENERATED_FLOWCHART_SUCCESS",
//       payload: { nodes, edges },
//     });

//     return { nodes, edges };
//   };


export const selectFlowchart = (flowchart) => ({
    type: SELECT_FLOWCHART,
    payload: flowchart
}); 